import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { alertAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(alertAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    alignItems: 'start',
    borderRadius: 'lg',
  },
  title: {
    fontWeight: 'medium',
  },
});

const sizes = {
  xs: {
    container: {
      fontSize: 'xs',
      lineHeight: 4,
      px: 2,
      py: 2,
    },
    icon: {
      height: 4,
      width: 4,
      mr: 1,
    },
    title: {
      lineHeight: 4,
      mr: 1,
    },
    description: {
      lineHeight: 4,
    },
  },
  sm: {
    container: {
      fontSize: 'sm',
      lineHeight: 5,
      px: 3,
      py: 2,
    },
    icon: {
      height: 5,
      width: 4,
      mr: 2,
    },
    title: {
      lineHeight: 5,
      mr: 1,
    },
    description: {
      lineHeight: 5,
    },
  },
  md: {
    container: {
      fontSize: 'md',
      lineHeight: 6,
      px: 4,
      py: 3,
    },
    icon: {
      height: 6,
      width: 5,
      mr: 2,
    },
    title: {
      lineHeight: 6,
    },
    description: {
      lineHeight: 6,
    },
  },
  lg: {
    container: {
      fontSize: 'lg',
      lineHeight: 6,
      px: 5,
      py: 4,
    },
    icon: {
      height: 6,
      width: 5,
      mr: 3,
    },
    title: {
      lineHeight: 6,
    },
    description: {
      lineHeight: 6,
    },
  },
  xl: {
    container: {
      fontSize: 'xl',
      lineHeight: 7,
      px: 6,
      py: 4,
    },
    icon: {
      height: 7,
      width: 6,
      mr: 3,
    },
    title: {
      lineHeight: 7,
    },
    description: {
      lineHeight: 7,
    },
  },
};

const subtleVariant = definePartsStyle(props => {
  const { colorScheme } = props;

  return {
    container: {
      a: {
        color: `${colorScheme}.600`,
      },
    },
    title: {
      color: `${colorScheme}.700`,
      _dark: {
        color: `${colorScheme}.300`,
      },
    },
  };
});

const statusBlockVariant = definePartsStyle(props => {
  const { colorScheme } = props;

  return {
    container: {
      bgColor: 'chakra-subtle-bg',
      borderColor: `${colorScheme}.400`,
      borderLeftWidth: 8,
      borderRadius: 'lg',
      flexDirection: 'column',
      pl: 5,
      pr: 7,
      py: 5,
      mb: 8,
    },
    title: {
      fontSize: '2xl',
      fontWeight: '600',
      letterSpacing: 'tighter',
      mb: 4,
    },
  };
});

// export the base styles in the component theme
export const alertTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    subtle: subtleVariant,
    'status-block': statusBlockVariant,
  },
});
